import React from "react";
import VideoMarquee from "./mini/VideoMarquee";


const VideoTestimonials = () => {
  return (
    <div className="w-full pt-5 text-center">
      <div className="">
        <h2 className="md:text-5xl text-2xl mt-5 font-bold ">
          HEAR WHAT OUR ALUMNI HAVE TO SAY
        </h2>
      </div>
      <div className="w-full grid md:grid-rows-1">
        <div className="md:block hidden">
          <VideoMarquee />
        </div>
      </div>
    </div>
  );
};

export default VideoTestimonials;
